import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';


class RoleAndStatusEntity {
  role?: string;
  status?: string;
  entity?: any;
}

@Directive({
  selector: '[awIsInRoleAndStatusForThisEntity]'
})
export class IsInRoleAndStatusForThisEntityDirective implements OnInit, OnDestroy {

  private hasView = true;
  private entity: any;
  private listOfConditions: RoleAndStatusEntity[] = [];

  constructor(
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
  }

  @Input() set awIsInRoleAndStatusForThisEntity(roleAndStatusEntityArray: RoleAndStatusEntity[]) {
    this.listOfConditions = roleAndStatusEntityArray;
    this.entity = roleAndStatusEntityArray[0].entity;
  }

  ngOnInit(): void {
    this.viewContainer.clear();
    this.hasView = false;
    const user = this.authService.loggedUser();

    if (this.hasView && this.listOfConditions.find(value => value.role == user?.role && value.status == this.entity?.status)) {
      this.viewContainer.clear();
      this.hasView = false;
    } else if (!this.hasView && this.listOfConditions.find(value => value.role == user?.role && value.status == this.entity?.status)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }

  }

  ngOnDestroy(): void {
  }

}
